var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperatingRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "33_\u624B\u672F\u5BA4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58,4H6A2,2,0,0,0,6,8H8V56a4,4,0,0,0,4,4l19.57-7.83a1.2,1.2,0,0,1,.86,0L52,60a4,4,0,0,0,4-4V8h2a2,2,0,0,0,0-4ZM52,55.68,33.91,48.45a5.11,5.11,0,0,0-3.82,0L12,55.68V8H52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22,40H42a2,2,0,0,0,0-4H40V25.91a8,8,0,0,0-16,0V36H22a2,2,0,0,0,0,4Zm6-14.12a4,4,0,0,1,8,0V36H28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperatingRoom);
export default __webpack_public_path__ + "static/media/operatingRoom.0154d962.svg";
export { ForwardRef as ReactComponent };